export default __webpack_public_path__ + "static/media/turkey.b628ca43.webp";